import {FormViewer, FormViewerContext} from '@wix/form-viewer/widget'
import {useBi, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppProps} from '../../hooks/runtime'
import {FormViewerContextProps, WixFormProps} from './interfaces'
import {classes} from './wix-form.st.css'

export const WixForm = ({
  formId,
  values,
  errors,
  overrides,
  onRegisterFormHandle,
  onChange,
  onValidate,
}: WixFormProps) => {
  const bi = useBi()
  const {i18n} = useTranslation()
  const appProps = useAppProps() as FormViewerContextProps

  return (
    <FormViewerContext {...appProps}>
      <div className={classes.form}>
        <FormViewer
          i18n={i18n}
          bi={bi}
          formId={formId}
          values={values}
          errors={errors}
          overrides={overrides}
          onValidate={onValidate}
          onChange={onChange}
          ref={onRegisterFormHandle}
        />
      </div>
    </FormViewerContext>
  )
}
